import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90f43a0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  rx: "4",
  ry: "4",
  width: "100",
  height: "40"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "148",
  y: "0",
  rx: "4",
  ry: "4",
  width: "140",
  height: "30"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "60",
  rx: "4",
  ry: "4",
  width: "200",
  height: "24"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "90",
  rx: "4",
  ry: "4",
  width: "160",
  height: "18"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "158",
  y: "130",
  rx: "4",
  ry: "4",
  width: "80",
  height: "24"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "273",
  cy: "143",
  r: "15"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createBlock(_component_md_card, {
    variant: "outlined",
    class: "payment-method-loader"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_content_loader, {
        viewBox: "0 0 288 158",
        speed: 1.2,
        primaryColor: "#dad9e3",
        secondaryColor: "#cecdd8"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }, 8, ["speed"])
    ]),
    _: 1
  }))
}